import { render, staticRenderFns } from "./batchView.vue?vue&type=template&id=8d490dda&scoped=true"
import script from "./batchView.vue?vue&type=script&lang=js"
export * from "./batchView.vue?vue&type=script&lang=js"
import style0 from "./batchView.vue?vue&type=style&index=0&id=8d490dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d490dda",
  null
  
)

export default component.exports